import { Injectable } from '@angular/core'
import { ModifyCustomCodeComponent } from '@tv3/containers/rentals/custom-codes/dialogs/modify/modify-custom-code.component'
import { CustomCode } from '@tv3/store/custom-codes/custom-code.model'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable({
  providedIn: 'root',
})
export class ModifyCustomCodeDialogService {
  constructor(private sidePanel: DialogService) {}

  open(customCode?: CustomCode) {
    this.sidePanel.openDrawer(ModifyCustomCodeComponent, {
      data: { code: customCode },
      panelClass: ['drawer-full-70'],
    })
  }
}
